module.exports = __webpack_public_path__ + "img/banner3.d9a0fa15.jpg";